import styled from 'styled-components'

export const Box = styled.div`
  width: 360px;
  padding: 32px;
  background: #ffffff;
`
